const Legend = () =>{

    return (
        <>
           
                <h3>Légende</h3>
                <div className="legendEntry"><img src="images/triangle.png" alt="triangle"/>Recommandation EPICES</div>
                <div className="legendEntry"><img src="images/square.png" alt="square"/>Mécanisme de défense soignants</div>
                <div className="legendEntry"><img src="images/circle.png" alt="circle"/>Mécanisme de défense patients</div>
            
        </>
    )
}

export {
    Legend
}